import { IUpdateControleAguaUseCase } from "../../../presentation/useCases/update/update_controle_agua_use_case";
import { UpdateControleAguaRequestModel, UpdateControleAguaResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateControleAguaUseCase
 */

export class UpdateControleAguaUseCase implements IUpdateControleAguaUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async updateControleAgua(model: UpdateControleAguaRequestModel): Promise<UpdateControleAguaResponseModel> {
    return await this.repository.updateControleAgua(model);
  }
}
